import IncidentReport from "./index";

const router = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "/incident-report",
      component: IncidentReport,
      auth: ["admin", "user", "manager"],
      settings: {
        layout: {
          head: true,
          sider: true,
        },
      },
    },
  ],
};

export default router; 